<template>
  <!-- <v-btn class="download-button" @click.stop="">start all the downloadin</v-btn> -->
  <div class="text-center">
    <v-menu offset-y>
      <template v-slot:activator="{ on, attrs }">
        <v-btn
          class="download-button"
          color="primary"
          dark
          v-bind="attrs"
          v-on="on"
        >
          Select Size
        </v-btn>
      </template>
      <v-list>
        <v-list-item
          v-for="(item, index) in sizeOptions"
          :key="index"
          @click="handleItemClick(item)"
        >
          <v-list-item-title>{{ item }}</v-list-item-title>
        </v-list-item>
      </v-list>
    </v-menu>
  </div>
</template>

<script>
// vuex
// library
// internal
// components
export default {
  props: {
    imageData: {
      required: true,
      type: Object
    }
  },
  methods: {
    handleItemClick(key) {
      const url = this.imageData.sizes[key]
      window.open(url, '_blank')
    }
  },
  computed: {
    sizeOptions() {
      return Object.keys(this.imageData.sizes)
    }
  }
}
</script>

<style lang="scss" scoped>
.download-button {
  margin-top: 5px;
}
</style>
